<template>
  <div
    :class="$style.root"
    :data-has-pagination="childData?.meta?.pagination?.page < childData?.meta?.pagination?.pageCount ? '' : null"
  >
    <LayoutPageHeaderComponent :data="localizedData" />

    <ul :class=$style.list>
      <li
        v-for="entry in childData?.data"
      >
        <I18nLinkWithFallback
          name="online-exhibitions-slug"
          :localizedData="getLocalizedData(entry)?.attributes"
          :class="$style.link"
        >
          <CoreImageComponent
            v-if="getImage(entry)"
            :image="getImage(entry)"
            :includeCaption="false"
            :class="$style.image"
          />
          {{ getTitle(getLocalizedData(entry)?.attributes) }}
        </I18nLinkWithFallback>
      </li>
    </ul>

    <LayoutPaginationComponent
      :pagination="childData?.meta?.pagination"
      :paginateChildData="paginateChildData"
    />
  </div>
</template>

<script setup>
import { sample } from 'lodash-es'

const props = defineProps({
  pageData: Object,
  childData: {
    type: Object,
    required: false,
  },
  paginateChildData: {
    type: Function,
    required: false,
  }
})

const getLocalizedData = i18nGetLocalizedData
const getTitle = (data) => i18nGetLocalizedTitle(data)
const getImage = (data) => {
  return sample(data?.attributes?.images)?.image?.data?.attributes
}


const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData?.data))
})
</script>

<style module lang="scss">
.root {
}

.list {
  composes: reset-list from global;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: var(--unit--horizontal);
  grid-row-gap: calc(var(--unit--vertical) * 2);

  padding-left: var(--unit--horizontal);
  padding-right: var(--unit--horizontal);

  @media (max-width: $breakpoint-s) {
    grid-template-columns: repeat(1, 1fr);
  }
}

.list li {
  width: 100%;
}

.link {
  composes: reset-link font-size-medium from global;
  display: flex;
  flex-direction: column;
  gap: var(--unit--vertical);
  text-align: center;
}

.image {
  transition: filter var(--transition--default);
  --base--image--aspect-ratio: 9 / 6;
}

.link:hover .image {
  filter: invert(100%) grayscale(100%);
}
</style>
